<template>
  <div>
    <div class="bg-white shadow-sm rounded-md h-auto">
      <div class="border-b-0.5 flex justify-between items-center">
        <p class="p-2 text-sm">Leave Balances</p>
      </div>
      <div class="flex flex-col gap-y-1 p-2" v-if="loading">
        <transition name="fade">
          <div
            v-if="loading"
            class="inset-0 absolute bg-black rounded-md bg-opacity-40 w-full"
          >
            <loader class="center-h-v" />
          </div>
        </transition>
      </div>
      <div
        class="flex flex-col gap-y-1 p-2"
        v-else-if="items.length > 0 && !loading"
      >
        <div
          class="text-xs p-2 flex justify-between border-1.5 rounded-md cursor-pointer"
          v-for="(item, index) in items"
          :key="index"
          @click="() => setLeaveSummary(item)"
        >
          <p class="font-semibold">{{ item?.name }}</p>
          <p :class="differenceClass(item?.difference)">
            {{ item?.difference }}
          </p>
        </div>
      </div>

      <div class="max-h-screen px-4" v-else>
        <div
          v-if="!loading || items.length === 0"
          class="flex flex-col justify-center items-center h-full mt-5"
        >
          <el-empty :image-size="70" description="No Data"></el-empty>
        </div>
      </div>
    </div>
    <DashboardLeaveBalances
      :show-summary="showSummary"
      :timeOffBalance="leaveSummary"
      :title="title"
      :close="close"
    ></DashboardLeaveBalances>
  </div>
</template>

<script>
import { fetchDataMixin } from "@/mixins/fetchDataMixin";
import axios from "axios";
import { mapGetters } from "vuex";
import DashboardLeaveBalances from "../employees/modals/dashboardLeaveBalances.vue";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "LeaveBalances",
  components: { Loader, DashboardLeaveBalances },
  mixins: [fetchDataMixin],
  data() {
    return {
      open: null,
      get_error: null,
      items: [],
      allData: {},
      showSummary: false,
      leaveSummary: [],
      title: "",
    };
  },
  created() {
    this.fetchDataSequentially();
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    close() {
      this.showSummary = false;
    },
    setLeaveSummary(leave) {
      this.title = leave.name;
      this.leaveSummary = [leave.value];
      this.showSummary = true;
    },
    differenceClass(difference) {
      return difference <= 2 ? "text-red-500" : "text-green-500";
    },
    async fetchDataSequentially() {
      try {
        await this.fetchMyLeaveTypes();
        await this.fetchLeaveSummaries();
        this.calculateDifferences();
      } catch (error) {
        console.error(error);
      }
    },
    async fetchMyLeaveTypes() {
      const url = `${this.getOrganization}/timeoff/me/leave/type/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      try {
        const response = await axios.get(url, options);
        this.data = response.data.Data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.error = error.message;
        setTimeout(() => {
          this.error = null;
        }, 1500);
        throw error;
      }
    },
    async fetchLeaveSummaries() {
      const leaveTypeIds = this.data.map((leaves) => leaves.LeaveTypeId);
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      const responses = await Promise.all(
        leaveTypeIds.map((leaveTypeId) =>
          axios.get(
            `${this.getOrganization}/timeoff/leave/type/${leaveTypeId}/v1/summary`,
            options
          )
        )
      );
      this.allData = responses.reduce((accumulator, response, index) => {
        const leaveType = this.data[index].LeaveType;
        accumulator[leaveType] = response.data.Data;
        return accumulator;
      }, {});
    },
    calculateDifferences() {
      const tData = Object.entries(this.allData).map(([name, value]) => ({
        name,
        value,
        difference: value.Available,
      }));
      this.items = tData;
    },
  },
};
</script>
